/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbRuleMapping {
    getFixupPrototypeFunction() { return ServiceNowCmdbRuleMapping.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbRuleMapping>): ServiceNowCmdbRuleMapping {
        let obj = Object.assign(new ServiceNowCmdbRuleMapping(), model);
        ServiceNowCmdbRuleMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbRuleMapping>): ServiceNowCmdbRuleMapping {
        if (!model) return null;
        return ServiceNowCmdbRuleMapping.newInstance(<ServiceNowCmdbRuleMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbRuleMapping) {
        if (!obj) return;

        models.ServiceNowCmdbRuleMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbRuleMapping): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbRuleMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * List of locations to filter
     */
    locations: Array<string>;

    /**
     * List of Cloud Account to filter
     */
    cloud_accounts: Array<string>;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

}
